import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalChatboxService } from './services/chat-box/external-chatbox.service';
import { ExternalToolsInitializerService } from './external-tools-initializer.service';

@NgModule({
  declarations: [],
  providers: [ExternalChatboxService, ExternalToolsInitializerService],
  imports: [CommonModule],
})
export class ExternalToolsModule {
  constructor() {}
}
